const _type = Symbol('type');

class SimpleCatalog extends Map {

  [_type]: string;

  constructor(type: string) {
    super();
    this[_type] = type;
  }

}

export default SimpleCatalog;
